import React from 'react';
import AdminLayout from './AdminLayout';
import { AdminRouteIds } from './AdminRoutes';
import ShipmentsActiveListTable from '../ShipmentsActiveListTable';


export default function ShipmentsActiveList() {
    const pageId = AdminRouteIds.shipments;

    return (
        <AdminLayout selectedId={pageId}>
            <div>
                <ShipmentsActiveListTable />
            </div>
        </AdminLayout>   
    );
}
